import { render, staticRenderFns } from "./ProjectCardList.vue?vue&type=template&id=6948a2be&scoped=true&"
import script from "./ProjectCardList.vue?vue&type=script&lang=ts&"
export * from "./ProjectCardList.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCardList.vue?vue&type=style&index=0&id=6948a2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6948a2be",
  null
  
)

/* custom blocks */
import block0 from "./ProjectCardList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports